export const localStorageService = {
  get,
  set,
  remove,
  cacheData,
  getCachedData,
}

export const sessionStorageService = {
  get: getFromSession,
  set: setToSession,
  remove: removeFromSession,
  cacheData: cacheDataToSession,
  getCachedData: getCachedDataFromSession,
}

function get(key) {
  const rawData = localStorage.getItem(key)
  if (!rawData) return null

  // If it's a string that starts with '/', it's likely a route path
  try {
    return JSON.parse(rawData)
    // eslint-disable-next-line no-unused-vars
  } catch (e) {
    // If parsing fails, return the raw data
    return rawData
  }
}

function set(key, value) {
  localStorage.setItem(key, JSON.stringify(value))
}

function remove(key) {
  localStorage.removeItem(key)
}

function cacheData(storageKey, data, expirationTime = 30 * 60 * 1000) {
  set(storageKey, {
    data,
    expirationTime: Date.now() + expirationTime,
  })
}

function getCachedData(storageKey) {
  const cachedData = get(storageKey) || {}
  if (cachedData?.data && isCacheValid(cachedData?.expirationTime)) {
    return cachedData.data
  } else return null
}

function getFromSession(key) {
  const rawData = sessionStorage.getItem(key)
  if (!rawData) return null
  return JSON.parse(rawData)
}

function setToSession(key, value) {
  sessionStorage.setItem(key, JSON.stringify(value))
}

function removeFromSession(key) {
  sessionStorage.removeItem(key)
}

function cacheDataToSession(storageKey, data, expirationTime = 30 * 60 * 1000) {
  setToSession(storageKey, {
    data,
    expirationTime: Date.now() + expirationTime,
  })
}

function getCachedDataFromSession(storageKey) {
  const cachedData = getFromSession(storageKey) || {}
  if (cachedData?.data && isCacheValid(cachedData?.expirationTime)) {
    return cachedData.data
  } else return null
}

function isCacheValid(cacheTimestamp) {
  return !!(Date.now() <= cacheTimestamp)
}
